export const SYSTEM_REPORT_COLS = [
    {
        field: 'branchofficename',
        header: 'Branch Office Name'
    },
    {
        field: 'customernumber',
        header: 'Customer Number'
    },
    {
        field: 'customername',
        header: 'Customer Name'
    },
    {
        field: 'sitenumber',
        header: 'Site Number'
    },
    {
        field: 'sitename',
        header: 'Site Name'
    },
    {
        field: 'contractnumber',
        header: 'Contract Number'
    },
    {
        field: 'contractname',
        header: 'Contract Name'
    },
    {
        field: 'paneltypename',
        header: 'Panel Type Name'
    },
    {
        field: 'flssystemname',
        header: 'System Name'
    },
    {
        field: 'systemstatus',
        header: 'System Status'
    },
    {
        field: 'systemaddress',
        header: 'System Address'
    },
    {
        field: 'softwareversion',
        header: 'Software Version'
    },
];